<template>
  <!-- 资产查询 -->
  <div class="page-digital-search m-digital">
    <div class="com-content">
      <div class="menu-left-box">
        <div class="menu-left">
          <div
            class="menu-left-item g-pointer"
            v-for="item in roleList"
            :key="item.id"
            :class="{'active': activeMenuId === item.id}"
            @click="handleClickMenu(item)"
          >
            <span>
              <svg-icon icon-class="myLaunch" style="font-size:14px;"/>
              &nbsp;{{item.name}}
            </span>
            <div class="menu" style="visibility:hidden">
              <!-- 菜单 -->
              <el-dropdown
                trigger="click"
                @command="handleOperate(item, $event)"
                @click.stop.native="nodeEditFocus"
              >
                <span>
                  <svg-icon
                    icon-class="more"
                    class-name="icon-common g-pointer"
                    style="font-size: 12px;color:#575962;"
                  />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="1">重命名</el-dropdown-item>
                  <el-dropdown-item command="2">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>

        <el-button class="btn-add" type="primary" size="small" @click="add('')">
          <svg-icon icon-class="add"/>&nbsp;新增角色
        </el-button>
      </div>

      <div class="content">
        <div class="mb-30" v-for="(item, index) in dataList" :key="index">
          <h1 class="title" style="margin-bottom:0;">
            {{item.functionName}}
            <span class="collapse g-pointer" @click="toggleShow(item)">
              {{item.isCollapse ? '展开' : '收起'}}
              <i
                :class="item.isCollapse?'el-icon-arrow-right':'el-icon-arrow-down'"
              ></i>
            </span>
          </h1>
          <div v-show="!item.isCollapse">
            <el-checkbox-group v-model="item.checkList">
              <template v-for="(it, i) in item.childrens">
                <el-checkbox
                  class="mt-20"
                  :label="it.functionId"
                  name="checkList"
                  :key="'otherlist'+i"
                  v-show="!it.childrens"
                  :disabled="pageType === 'detail'"
                >{{it.functionName}}</el-checkbox>

                <!-- 全选 -->
                <div :key="'other'+i" v-show="it.childrens">
                  <el-checkbox
                    class="mt-30"
                    @change="handleCheckAllChange(it, $event)"
                    :indeterminate="it.checkList && it.childrens && it.checkList.length > 0 && (it.checkList.length < it.childrens.length)"
                    :label="it.functionId"
                    :disabled="pageType === 'detail'"
                  >{{it.functionName}}</el-checkbox>

                  <span class="collapse g-pointer" @click="toggleShow(it)">
                    {{item.isCollapse ? '展开' : '收起'}}
                    <i
                      :class="item.isCollapse?'el-icon-arrow-right':'el-icon-arrow-down'"
                    ></i>
                  </span>
                </div>

                <el-checkbox-group
                  class="mt-10"
                  v-model="it.checkList"
                  :key="i"
                  v-show="it.childrens && !it.isCollapse"
                  @change="handleCheckedChange(item, it)"
                >
                  <el-checkbox
                    :label="row.functionId"
                    name="checkList"
                    v-for="(row, j) in it.childrens"
                    :key="j"
                    :disabled="pageType === 'detail'"
                  >{{row.functionName}}</el-checkbox>
                </el-checkbox-group>
              </template>

              <!-- <el-checkbox v-model="item.checkAll" @change="handleCheckAllChange">全选</el-checkbox>

              <el-checkbox
                :label="it.id"
                name="checkList"
                v-for="(it, i) in item.checkArr"
                :key="i"
              >{{it.label}}</el-checkbox>-->
            </el-checkbox-group>
          </div>
        </div>

        <div class="btn-operate">
          <el-button type="primary" @click="pageType='edit'" v-show="pageType==='detail'">编辑</el-button>

          <el-button
            type="primary"
            @click="save"
            :loading="loadingSave"
            v-show="pageType==='edit'"
          >保存</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageType: 'detail', // detail edit
      activeMenuId: 1,
      roleList: [],
      totalIds: [],
      loadingSave: false,
      dataList: [
        {
          label: '首页',
          id: '1',
          checkList: ['11'],
          childrens: [
            {
              label: '工作台',
              id: '11'
            },
            {
              label: '分析台',
              id: '12'
            },
            {
              label: '监控台',
              id: '13'
            }
          ]
        },
        {
          label: '藏品',
          id: '2',
          checkList: ['22'],
          childrens: [
            {
              label: '藏品档案',
              id: '21',
              checkList: ['211'],
              childrens: [
                {
                  label: '藏品管理',
                  id: '211'
                },
                {
                  label: '藏品统计',
                  id: '212'
                },
                {
                  label: '藏品总账',
                  id: '213'
                }
              ]
            },
            {
              label: '基础资料',
              id: '22',
              checkList: ['221', '222', '223'],
              childrens: [
                {
                  label: '分类别列表',
                  id: '221'
                },
                {
                  label: '标签列表',
                  id: '222'
                },
                {
                  label: '公开字段',
                  id: '223'
                }
              ]
            }
          ]
        }
      ]
    }
  },
  methods: {
    getRoleList() {
      this.$http.get('/role/listRole').then(res => {
        if (res.success) {
          let data = res.result
          this.roleList = data
          this.activeMenuId = data[0].id
          this.getDataList()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    getDataList() {
      this.$http
        .get('/function/getListByRoleId', {
          roleId: this.activeMenuId
        })
        .then(res => {
          if (res.success) {
            this.dataList = res.result
          } else {
            this.$message.error(res.message)
          }
        })
    },

    handleClickMenu(item) {
      this.pageType = 'detail'
      this.activeMenuId = item.id
      this.getDataList()
    },
    handleCheckAllChange(it, val) {
      if (val) {
        it.checkList = []
        it.childrens.forEach(item => {
          it.checkList.push(item.functionId)
        })
      } else {
        it.checkList = []
      }
    },
    handleCheckedChange(item, child) {
      // if (child.checkList.length < child.childrens.length) {
      if (child.checkList.length === 0) {
        item.checkList.splice(item.checkList.indexOf(child.functionId), 1)
      } else {
        if (!item.checkList.includes(child.functionId)) {
          item.checkList.push(child.functionId)
        }
      }
    },
    toggleShow(item) {
      this.$set(item, 'isCollapse', !item.isCollapse)
    },
    // 点击菜单面板
    handleOperate(data, type) {
      switch (type) {
        // 编辑
        case '1':
          this.add(data)
          break
        // 删除部门
        case '2':
          this.remove(data)
          break
      }
    },
    // 阻止事件冒泡
    nodeEditFocus() {},
    add(item) {
      this.$prompt('', '角色名称', {
        showClose: true,
        // showCancelButton: false,
        confirmButtonText: '确定',
        inputPlaceholder: '请输入',
        inputValue: (item && item.name) || null,
        // inputPattern: /^[\S]{1,10}$/,
        inputPattern: /^.{1,10}$/,
        inputErrorMessage: '请输入1到10位字符'
        // center: true
      })
        .then(({ value }) => {
          if (!item) {
            this.addRemote(value)
          } else {
            this.editRemote(item, value)
          }
        })
        .catch(() => {})
    },
    addRemote(value) {
      this.$http
        .post('/role/addRole', {
          name: value
        })
        .then(res => {
          if (res.success) {
            this.$message.success('新增角色成功')
            this.getRoleList()
          } else {
            this.$message.error(res.message)
          }
        })
    },
    editRemote(item, value) {
      this.$http
        .post('/role/updateRole', {
          id: item.id,
          name: value
        })
        .then(res => {
          if (res.success) {
            this.$message.success('重命名角色成功')
            this.getRoleList()
          } else {
            this.$message.error(res.message)
          }
        })
    },
    remove(item) {
      this.$common.confirm(
        {
          title: '您正在删除角色，是否确认删除？',
          className: 'cus-confirm-375'
        },
        () => {
          this.$http
            .post('/role/deleteRole', {
              id: item.id
            })
            .then(res => {
              if (res.success) {
                this.$message.success('删除角色成功')
                this.getRoleList()
              } else {
                this.$message.error(res.message)
              }
            })
        }
      )
    },
    getId(dataArr) {
      dataArr.forEach(item => {
        if (item.checkList && item.checkList.length) {
          this.totalIds = this.totalIds.concat(item.checkList)
        }
        if (item.childrens && item.childrens.length) {
          this.getId(item.childrens)
        }
      })
    },
    save() {
      this.totalIds = []
      this.getId(this.dataList)

      this.loadingSave = true
      this.$http
        .post('/function/save', {
          roleId: this.activeMenuId,
          functionIds: this.totalIds.join(',')
        })
        .then(res => {
          this.loadingSave = false
          if (res.success) {
            this.$message.success(res.message)
            this.pageType = 'detail'
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(() => {
          this.loadingSave = false
        })
    }
  },
  created() {
    this.getRoleList()
  }
}
</script>


<style lang="scss" scoped>
.page-digital-search {
  // display: flex;
  border-radius: 4px;
  background: #fff;
  height: 100%;
  .com-content {
    padding: 0;
  }
  .menu-left-box {
    float: left;
    position: relative;
    height: 100%;
    padding-bottom: 50px;
    box-sizing: border-box;
    .btn-add {
      position: absolute;
      bottom: 20px;
      left: 20px;
    }
  }
  .menu-left {
    float: left;
    min-width: 200px;
    height: 100%;
    position: relative;
    padding: 20px 0;
    box-sizing: border-box;
    border-right: solid 1px $border;
    overflow-y: auto;
    .menu-left-item {
      position: relative;
      padding: 0 20px;
      box-sizing: border-box;
      line-height: 40px;
      font-size: 14px;
      color: $color5;
      &.active {
        color: #0590ff;
        background-color: #e6f3ff;
      }
      .menu {
        position: absolute;
        right: 10px;
        top: 0;
      }
      &:hover {
        background-color: $color3;
        .menu {
          // display: block;
          visibility: visible !important;
        }
      }
    }
  }
  .content {
    position: relative;
    padding: 30px;
    // padding: 30px 20px 0 200px;
    box-sizing: border-box;
    height: 100%;
    overflow-y: auto;
    .title {
      // padding-left: 10px;
      // border-left: solid 5px $primary;
      &:before {
        margin-right: 10px;
        position: relative;
        top: 3px;
        display: inline-block;
        content: '';
        width: 5px;
        height: 18px;
        background: $primary;
      }
    }
    .collapse {
      margin-left: 50px;
      font-size: 14px;
      color: $color5;
      font-weight: normal;
    }
    .btn-operate {
      position: fixed;
      right: 100px;
      top: 120px;
    }
  }
}
</style>

